<template>
  <div class="gam-gambit-result-skeleton" aria-hidden="true">
    <div class="location-row">
      <div class="icon skeleton o-1" />
      <div class="name skeleton o-1" />
    </div>

    <div class="title-timeframe">
      <div class="timeframe skeleton o-2" />
    </div>

    <div class="tags-row">
      <div class="tag skeleton o-3" />
      <div class="tag skeleton o-3" />
      <div class="tag skeleton o-3" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/ui/css/partial';

.gam-gambit-result-skeleton {
  @extend %tinted-card;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
  pointer-events: none;
}

.title-timeframe {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.timeframe {
  width: 80%;
  height: 13px;
  border-radius: 40px;
}

.location-row {
  display: flex;
  align-items: center;
  gap: 0.33rem;
}

.icon {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.name {
  width: 50%;
  height: 13px;
  border-radius: 40px;
}

.tags-row {
  display: flex;
  gap: 0.5rem;
  margin-top: 4px;
}

.tag {
  height: 22px;
  border-radius: 40px;

  &:nth-child(1) {
    width: 50px;
  }

  &:nth-child(2) {
    width: 60px;
  }

  &:nth-child(3) {
    width: 70px;
  }
}
</style>
